<template>
  <div
    :class="{'expand-menu-sidebar' : isExpand}"
    class="toggled">

    <!-- header title -->
    <j-headful :title="$route.meta.title"/>

    <!-- sidebar -->
    <!-- <j-sidebar-home
      :menus-items="menusDetails"
      class="siderbar-app"
      @set-expand="expandMenu"/> -->

    <div
      v-if="sidebar"
      class="background-blur show"
      @click="$store.dispatch('jStoreSetting/toogleSidebar', false)"/>

    <!-- Page Content -->
    <div
      id="page-content-wrapper"
      style="display: block">

      <!-- navbar -->
      <j-navbar-home-siswa />

      <!-- main content -->
      <div>
        <transition name="fadeout">
          <router-view/>
        </transition>
      </div>

    </div>

    <!-- notification screen -->
    <j-loading-screen
      ref="loadingScreen"
      :message="loading_message"/>
    <j-info-screen
      ref="infoScreen"
      :message="info_message"/>
    <problem-screen
      ref="problemScreen"
      :message="problem_message"
      :code="problem_code"/>
    <success-screen
      ref="successScreen"
      :message="success_message"/>

  </div>
</template>

<script>
/* eslint-disable global-require,import/no-duplicates,vue/name-property-casing */
import { jPrivCompanySettings } from '@/privilage/company-settings/jPrivCompanySettings';
import { jPrivPackages } from '@/privilage/packages/jPrivPackages';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';
import { mapState } from 'vuex';
import jMixNotificationScreen from '@/mixins/components/notification-screen/jMixNotificationScreen';
import jNavbarHomeSiswa from '@/layouts/navbar/jNavbarHomeSiswa';
import jSidebarHome from '@/layouts/sidebar/jSidebarApp';
// import loadingScreen from '@/components/notification-screen/jLoadingScreen';
import successScreen from '@/components/notification-screen/jSuccessScreen';
import problemScreen from '@/components/notification-screen/jProblemScreen';
import Vue from 'vue';

export default {
  name: 'jHomeSiswaWrapper',
  components: {
    jNavbarHomeSiswa,
    jSidebarHome,
    // loadingScreen,
    successScreen,
    problemScreen,
  },
  mixins: [
    jPrivCompanySettings,
    jPrivPackages,
    jPrivRoles,
    jMixNotificationScreen,
  ],
  data() {
    return {
      isExpand: false,
      moduleActive: 'setting',
      window: {
        width: 0,
        height: 0,
      },
    };
  },
  computed: {
    ...mapState('jStoreSetting', ['sidebar']),

    menusDetails() {
      if (this.moduleActive === 'kurikulum') {
        return [
          {
            parent: {
              name: 'KEPEGAWAIAN',
              icon: 'file-text-o',
              href: '/kepegawaian',
              isShow: this.cekAccess(['admin', 'kepala_sekolah', 'kepegawaian']),
            },
          },
          // {
          //   parent: {
          //     name: 'ADMINISTRASI KELAS',
          //     icon: 'file-text-o',
          //     href: '/admin-kelas',
          //     isShow: this.cekAccess(['admin', 'kepala_sekolah', 'kepegawaian']),
          //   },
          // },
          {
            parent: {
              name: 'ADMINISTRASI PEMBELAJARAN',
              icon: 'file-text-o',
              isShow: this.cekAccess(['admin', 'kepala_sekolah', 'kesiswaan', 'guru', 'wali_kelas']),
            },
            child: [
              {
                name: 'DOKUMEN SAYA',
                href: '/admin-pembelajaran/dokumen-saya',
                icon: 'file',
                isShow: true,
              },
              {
                name: 'SUBMISSION',
                href: '/admin-pembelajaran/requester',
                icon: 'file',
                isShow: true,
              },
              {
                name: 'APPROVER',
                href: '/admin-pembelajaran/approver',
                icon: 'file',
                isShow: true,
              },
            ],
          },
          {
            parent: {
              name: 'ADMINISTRASI SURAT MENYURAT',
              icon: 'file-text-o',
              isShow: this.cekAccess(['admin', 'kepala_sekolah', 'guru']),
            },
            child: [
              {
                name: 'SURAT SAYA',
                href: '/admin-surat/surat-saya',
                icon: 'file',
                isShow: true,
              },
              {
                name: 'SUBMISSION',
                href: '/admin-surat/requester',
                icon: 'file',
                isShow: true,
              },
              {
                name: 'APPROVER',
                href: '/admin-surat/approver',
                icon: 'file',
                isShow: true,
              },
            ],
          },
          {
            parent: {
              name: 'LAPORAN WALI KELAS',
              icon: 'file-text-o',
              isShow: this.cekAccess(['admin', 'kepala_sekolah', 'kesiswaan', 'kurikulum', 'wali_kelas', 'kajur']),
            },
            child: [
              {
                name: 'LAPORAN SAYA',
                href: '/laporan-walikelas/laporan-saya',
                icon: 'file',
                isShow: true,
              },
              {
                name: 'SEMUA LAPORAN',
                href: '/laporan-walikelas/semua-laporan',
                icon: 'file',
                isShow: true,
              },
            ],
          },
        ];
      } else if (this.moduleActive === 'kesiswaan') {
        return [
          {
            parent: {
              name: 'DATA SISWA',
              icon: 'file-text-o',
              href: '/data-siswa',
              isShow: this.cekAccess(['admin', 'kepala_sekolah', 'kurikulum', 'wali_kelas', 'kesiswaan', 'guru', 'tu', 'sapras', 'hubin', 'tefa', 'kajur', 'siswa']),
            },
          },
          {
            parent: {
              name: 'E-BUKU SAKU SISWA',
              icon: 'file-text-o',
              isShow: this.cekAccess(['admin', 'kepala_sekolah', 'wali_kelas', 'kesiswaan', 'guru', 'siswa']),
            },
            child: [
              {
                name: 'SUBMISSION',
                href: '/buku-saku-siswa',
                icon: 'file',
                isShow: true,
              },
              {
                name: 'APPROVER',
                href: '/buku-saku-siswa/approver',
                icon: 'file',
                isShow: true,
              },
            ],
          },
          {
            parent: {
              name: 'ADMINISTRASI EKSTRAKULIKULER',
              icon: 'file-text-o',
              href: '/data-ekskul',
              isShow: this.cekAccess(['admin', 'kepala_sekolah', 'wali_kelas', 'kesiswaan', 'siswa']),
            },
          },
          {
            parent: {
              name: 'APPROVER SURAT DISPEN',
              icon: 'file-text-o',
              href: '/approver-dispen',
              isShow: this.cekAccess(['admin', 'kepala_sekolah', 'wali_kelas', 'kesiswaan', 'siswa']),
            },
          },
        ];
      } else if (this.moduleActive === 'bk') {
        return [
          {
            parent: {
              name: 'KONSELING',
              icon: 'file-text-o',
              href: '/konseling',
              isShow: this.cekAccess(['admin', 'kepala_sekolah', 'wali_kelas', 'kesiswaan']),
            },
          },
          {
            parent: {
              name: 'PENELURUSAN LULUSAN',
              icon: 'file-text-o',
              href: '/penelurusan-lulusan',
              isShow: this.cekAccess(['admin', 'kepala_sekolah', 'wali_kelas', 'kesiswaan', 'hubin', 'kajur']),
            },
          },
          {
            parent: {
              name: 'PENELURUSAN CALON PENERIMA BANTUAN',
              icon: 'file-text-o',
              href: '/penelurusan-calon-penerima-bantuan',
              isShow: this.cekAccess(['admin', 'kepala_sekolah', 'wali_kelas', 'kesiswaan', 'tu']),
            },
          },
        ];
      } else if (this.moduleActive === 'hubin') {
        return [
          {
            parent: {
              name: 'MITRA',
              icon: 'file-text-o',
              href: '/mitra',
              isShow: this.cekAccess(['admin', 'kepala_sekolah', 'wali_kelas', 'kesiswaan', 'kurikulum', 'sapras', 'hubin', 'kajur']),
            },
          },
          {
            parent: {
              name: 'PENGUMUMAN',
              icon: 'file-text-o',
              href: '/pengumuman',
              isShow: this.cekAccess(['admin', 'kepala_sekolah', 'wali_kelas', 'kesiswaan', 'kurikulum', 'sapras', 'hubin', 'kajur']),
            },
          },
          {
            parent: {
              name: 'E-BUKU TAMU',
              icon: 'file-text-o',
              href: '/buku-tamu',
              isShow: this.cekAccess(['admin', 'kepala_sekolah', 'kesiswaan', 'kurikulum', 'sapras', 'hubin', 'kajur']),
            },
          },
        ];
      } else if (this.moduleActive === 'setting') {
        return [
          {
            parent: {
              name: 'DATA TAHUN AJARAN',
              icon: 'file-text-o',
              href: '/data-tahunajaran',
              isShow: this.cekAccess(['admin', 'kepala_sekolah', 'kepegawaian']),
            },
          },
          {
            parent: {
              name: 'DATA MASTER KELAS',
              icon: 'file-text-o',
              href: '/data-kelas',
              isShow: this.cekAccess(['admin', 'kepala_sekolah', 'kepegawaian']),
            },
          },
          // {
          //   parent: {
          //     name: 'DATA MASTER POIN',
          //     icon: 'file-text-o',
          //     href: '/data-poin',
          //     isShow: this.cekAccess(['admin', 'kepala_sekolah', 'kepegawaian']),
          //   },
          // },
        ];
      }
      return [];
    },
  },
  watch: {
    $route() {
      this.$store.dispatch('jStoreSetting/toogleSidebar', false);
      if (this.window.width < 1170) {
        this.$store.dispatch('jStoreLogin/hideSidebar');
      }
      // this.$store.dispatch('jStoreLogin/hideSidebar');
    },
  },
  mounted() {
    setInterval(() => {
      if (!Vue.ls.get('Token')) {
        this.$router.replace('/logout');
        window.location = '/';
      }
    }, 1000);
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.$store.dispatch('jStoreSetting/toogleSidebar', false);
    if (this.window.width < 1170) {
      this.$store.dispatch('jStoreLogin/hideSidebar');
    }
    // this.$store.dispatch('jStoreLogin/hideSidebar');
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    expandMenu(data, module) {
      this.isExpand = data;
      this.moduleActive = module;
    },
    cekAccess(haveAccess) {
      const roles = JSON.parse(localStorage.getItem('roles'));
      return roles.filter(f => haveAccess.includes(f.name)).length > 0;
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      localStorage.setItem('window', JSON.stringify(this.window));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/layouts/jHomeSiswaWrapper.vue